import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { PageTitle } from "../../components/PageTitle";
import { Input, message } from "antd";
import styled from "styled-components";
import { submitFeedback } from "../../services/api";

const { TextArea } = Input;

export const HilfeKontakt: React.FC = () => {
    const [feedbackText, setFeedbackText] = useState("");

    const feedbackMutation = useMutation({
        mutationFn: (text: string) => submitFeedback(text),
        onSuccess: () => {
            message.success("Vielen Dank für Ihr Feedback!");
            setFeedbackText("");
        },
        onError: () => {
            message.error("Feedback konnte nicht gesendet werden");
        }
    });

    const handleSubmit = () => {
        if (!feedbackText.trim()) {
            message.warning("Bitte geben Sie Ihre Nachricht ein");
            return;
        }
        feedbackMutation.mutate(feedbackText);
    };

    return (
        <div>
            <PageTitle
                title="Hilfe & Kontakt"
                mainBtnText="Senden"
                onMainBtnClick={handleSubmit}
                isLoading={feedbackMutation.isPending}
            />

            <ContentContainer>
                <Description>
                    Haben Sie Fragen oder Anregungen? Wir freuen uns über Ihr Feedback!
                </Description>

                <StyledTextArea
                    value={feedbackText}
                    onChange={(e) => setFeedbackText(e.target.value)}
                    placeholder="Ihre Nachricht..."
                    rows={8}
                    maxLength={2000}
                    showCount
                />
            </ContentContainer>
        </div>
    );
};

const ContentContainer = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 0 16px;
`;

const Description = styled.p`
    font-size: 16px;
    margin-bottom: 24px;
    color: rgba(0, 0, 0, 0.65);
`;

const StyledTextArea = styled(TextArea)`
    font-size: 16px;

    &:focus {
        border-color: #8b5cf6;
        box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.1);
    }
`;